module.exports = __webpack_public_path__ + "img/black03_128.23f12ad8.png";